import React from 'react';
import CustomSwiper from '@/_application/core/components/ui/custom-swiper';
import {SwiperSlide} from 'swiper/react';
import {ImageOptimized} from '@/_application/core/components/ui/image';
import {convertUrlToNewSite} from '@/_application/core/utils/convert-url';
import {Banner} from '@/__generated__/__types__';
import {getBannerUrlByPath} from '@/_application/helpers/cdn-image';

function MainBannerSwiper({mainBanner}: {mainBanner: Banner[]}) {
    if (mainBanner?.length === 0) {
        return <></>;
    }

    return (
        <div data-testid="main-banner-swiper" className="group/main-banner h-full">
            <CustomSwiper
                className="h-full rounded-[20px]"
                hasPagination
                hasNavigation
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }}
                buttonPrevClassName="opacity-50 left-5 group-hover/main-banner:opacity-100"
                buttonNextClassName="opacity-50 right-5 group-hover/main-banner:opacity-100">
                {mainBanner.map((item, index) => (
                    <>
                        {item?.image && (
                            <SwiperSlide key={item?.banner_id ?? `${item?.banner_id}_${index}`}>
                                <a href={`${convertUrlToNewSite(item?.url_banner ?? '/')}`} target="_self">
                                    <div className="relative h-[296px] w-full">
                                        <ImageOptimized
                                            className="object-cover"
                                            src={getBannerUrlByPath(item?.image)}
                                            alt={item?.name ?? 'banner-image'}
                                            fill
                                            sizes="100%"
                                            quality={100}
                                            loading={index === 0 ? 'eager' : 'lazy'}
                                            priority={index === 0}
                                        />
                                    </div>
                                </a>
                            </SwiperSlide>
                        )}
                    </>
                ))}
            </CustomSwiper>
        </div>
    );
}

export default MainBannerSwiper;
